import React, {Component} from 'react';
import { withTranslation } from 'react-i18next';
import {connect} from "react-redux";
import {notify} from "../../../../../../../../../actions/sharingDetailsActions";

class Notify extends Component {

    constructor(props) {
        super(props);

        this.notifyHandler = this.notifyHandler.bind(this);
    }

    notifyHandler(){
        this.props.setNotify(!this.props.notify)
    }

    render() {
        return (
            <div className="custom-control custom-checkbox mr-sm-2">
                <input type="checkbox" className="custom-control-input" id="notify" defaultChecked={this.props.notify} onChange={this.notifyHandler}/>
                <label className="custom-control-label" htmlFor="notify">
                    {this.props.t("popupSharingNotify")}
                </label>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        notify: state.sharingDetailsReducer.notify
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        setNotify : (boolean) => {
            dispatch(notify(boolean))
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Notify));